export const APPLICANT_TYPE = 'applicantType'; // 申请人类型
export const GMT_STATUS = 'gmtStatus'; // 贷款期限
export const LOAN_AMOUNT = 'loanAmount'; // 贷款额度
export const STATUS = 'status'; // 申请进度
export const GMT_INFORMATION_STATUS = 'gmtInformationStatus'; // 申请时间
export const BASIC_TYPE = 'basicType'; // 主体类型
export const BUSINESS_TYPE = 'businessType'; // 主营业务类型
export const LOAN_TYPE = 'loanType'; // 资金用途
export const BUSINESS_STATUS = 'businessStatus'; // 业务类型
export const BASIC_LEVEL = 'basicLevel'; // 主体等级
export const USE_POSITION_TYPE = 'userPositionType'; // 经办人身份
export const AGRICULTURE_CATEGORY = 'agricultureCategory'; // 企业产业区分
export const ORIENTATIO_TYPE = 'orientatio_type'; // 贷款投向
export const BUSINESS_UNIT = 'businessUnit'; // 经营种类计量单位
export const PROJECT_TYPE = 'projectType'; // 重大项目-项目类型
export const RATING_CREDIT = 'ratingCredit'; // 重大项目-信用等级
export const ENTERPRISE_TYPE = 'enterpriseType'; // 重大项目-企业类型
export const CAPITAL_PROJECT_TYPE = 'SocialCapitalProjectType'; // 招商项目-项目类型
export const CAPITAL_AMOUNT_TYPE = 'SocialCapitalWebAmountStatus'; // 招商项目-项目金额
export const FACILITY_LOAN_TYPE = 'facilityLoanType'; // 贷款贴息-贷款类型
export const GUARANTEE_LEVEL = 'guaranteeLevel'; // 担保奖补-担保公司级别
export const COMPANY_FUND_TYPE = 'establishmentType'; // 担保奖补-公司设立类型
export const SPECIAL_PROJECT_NAME = 'specialProjectName'; // 农产品加工补贴-子项目名称
export const SPECIAL_AGRICULTURAL_TYPE = 'specialAgriculturalType'; // 农产品加工补贴-建设性质
export const POLICY_CARD_TYPE = 'policyCardType'; // 政策通知管理-政策明白卡-政策级别
export const POLICY_LEVEL = 'policyType';// 政策-层次

export const CQ_BUSINESS_TYPE = 'cqBusinessType'; // 优选专区-重庆申请经营类型
export const FACILITY_PROJECT_TYPE = 'facilityProjectType'; // 设施农业- 项目类型

export const POLICY_MORE_TYPE = 'policyMoreType'; // 政策明白卡- 政策类型
export const POLICY_CARD_SUPPORT_OBJECT = 'policyCardSupportObject'; // 政策明白卡-支持对象
export const PROJECT_RESERVE_PROJECT = 'projectReserveProject'; // 重大项目-所属产业链
export const LGG_ACCOUNT_TYPE = 'largeGrainGrowerAccountType'; // 种粮大户补贴-账户类型
export const LGG_MANAGER_TYPE = 'largeGrainGrowerManagerType'; // 种粮大户补贴-经营主体类型

export const XMDD_ARG_PRO = 'agriproductFundUtilizationSubItem'; // 项目调度-农产品加工项目-资金使用情况中子项名称
export const XMDD_BILLION_PRO = 'billionProjectFundUtilizationSubItem'; // 项目调度-千亿农业优势产业培育项目-资金使用情况中子项名称
export const XMDD_STATUS = 'projectSchedulingStatus'; // 项目调度-我的项目类型

export const SPC_COMPANY_ROLE = 'financeChainMainRole'; // 供应链-企业角色
export const SPECIAL_ENTER_NAME = 'specialEnterType'; // 农产品加工补贴-企业类型

export const applicantType = { // 使用对象
  1: '个人',
  2: '企业',
  3: '个人/企业',
};

export const policyType = { // 通知
  0: { name: '中央通知', class: 'zczx__tag' },
  1: { name: '省级通知', class: 'zczx__tag-s' },
  2: { name: '市州通知', class: 'zczx__tag-z' },
  3: { name: '区县通知', class: 'zczx__tag-q' },
};

// 优选专区type, 2中国银行；4重庆银行；
export const SPECIAL_OFFER_TYPE = [4];
// 设置超时为2分钟
export const TIME_OUT = 120000;

// “1+1+8”专属产品
export const EXCLUSIVE_PRODUCTS_TYPE = [5];

// 重大项目新增字典-项目性质
export const ZD_PROJECT_NATURE = 'project_nature';
// 重大项目新增字典-财政资金支持类型
export const ZD_FINANCIAL_SUPPORT = 'financial_support';
// 重大项目-已完成前期审批手续
export const ZD_PRO_COMPLETED = 'procedures_completed';
// 重大项目-主体类型
export const ZD_SUBJECT_TYPE = 'subject_type';
// 重大项目-企业类型
export const ZD_ENTERPRISE_TYPE = 'enterpriseType';
